<header class="background-header">
	<img src="../../assets/img/{{themeService.theme}}/header-background.svg" alt="" class="background-header-img" [ngClass]="{backgroundWidth: themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
</header>
<section class="container simple-container request-submitted-container">
	<div><i class="fa fas fa-check-circle"></i></div>
	<h1>Request Submitted</h1>
	<p>We have received your request and one of the team will be in touch <br> with you shortly.</p>
	<p>In the meantime, please, gather the appropriate documentation <br> e.g medical note or detah certificate. These
		will be required as <br> part of our verification process.</p>
</section>
